import * as React from 'react';
import CustomThemeProvider from '../../ThemeProvider';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import CustomHeader from '../Component/Header';
import Header from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Header';
import { DesignerScreen } from './DesignerScreen';
import AmountPrice from '../Component/AmountPrice';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import Loader from '../Component/Loader/Loader';
import GlobalLoader from '@configuratorware/configurator-frontendgui/App/Shared/Containers/GlobalLoader';
import SaveConfiguration from '@configuratorware/configurator-frontendgui/App/Shared/Containers/SaveConfiguration';
import LoadConfiguration from '../../Shared/Containers/LoadConfigurationContainer';

const CustomAmountPriceContainer = (props) => {
  return <AmountPriceContainer Component={AmountPrice} {...props} />;
};

const CustomDesignerScreen = (props) => (
  <DesignerScreen {...props} renderHeader={() => <Header Component={CustomHeader} {...props} />} />
);

const CustomLoader = (props) => {
  return <GlobalLoader {...props} Component={Loader} />;
};

const CustomSaveConfiguration = (props) => {
  return <SaveConfiguration {...props} ProgressComponent={Loader} />;
};

const CustomConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    ThemeProvider={CustomThemeProvider}
    DesignerScreen={CustomDesignerScreen}
    renderAmountPrice={CustomAmountPriceContainer}
    renderLoader={CustomLoader}
    renderSaveConfiguration={CustomSaveConfiguration}
    renderLoadConfiguration={() => <LoadConfiguration />}
  />
);

export default CustomConfiguratorScreen;
